import * as actionsTypesMembers from '../../actions/actionsTypesMembers'

function initialAllClicksState() {
  return {
    isLoading: false,
    isError: false,
    isSuccess: false,
    allClicksData: [],
  }
}
export function getAllClicks(state, action) {
  let previousState = (state ? state : initialAllClicksState())
  const { isLoading, isError, isSuccess, allClicksData } = action

  switch (action.type) {
    case actionsTypesMembers.ALL_CLICKS_REQUEST :
      return {
        ...previousState,
        isLoading,
        isError: false,
        isSuccess: false,
        allClicksData: [],
      }
    case actionsTypesMembers.ALL_CLICKS_FAILURE :
      return {
        ...previousState,
        isError,
        isSuccess: false,
        allClicksData: [],
      }
    case actionsTypesMembers.ALL_CLICKS_SUCCESS:
      return {
        ...previousState,
        isSuccess,
        isError: false,
        allClicksData,
      }
    default :
      return previousState
  }
}

function initialAllSouscriptionsState() {
  return {
    isLoading: false,
    isError: false,
    isSuccess: false,
    allSouscriptionsData: [],
  }
}
export function getAllSouscriptions(state, action) {
  let previousState = (state ? state : initialAllSouscriptionsState())
  const { isLoading, isError, isSuccess, allSouscriptionsData } = action

  switch (action.type) {
    case actionsTypesMembers.ALL_SOUSCRIPTIONS_REQUEST :
      return {
        ...previousState,
        isLoading,
        isError: false,
        isSuccess: false,
        allSouscriptionsData: [],
      }
    case actionsTypesMembers.ALL_SOUSCRIPTIONS_FAILURE :
      return {
        ...previousState,
        isError,
        isSuccess: false,
        allSouscriptionsData: [],
      }
    case actionsTypesMembers.ALL_SOUSCRIPTIONS_SUCCESS:
      return {
        ...previousState,
        isSuccess,
        isError: false,
        allSouscriptionsData,
      }
    default :
      return previousState
  }
}

function initialWeekSouscriptionsState() {
  return {
    isLoading: false,
    isError: false,
    isSuccess: false,
    weekSouscriptionsData: [],
  }
}
export function getWeekSouscriptions(state, action) {
  let previousState = (state ? state : initialWeekSouscriptionsState())
  const { isLoading, isError, isSuccess, weekSouscriptionsData } = action

  switch (action.type) {
    case actionsTypesMembers.WEEK_SOUSCRIPTIONS_REQUEST :
      return {
        ...previousState,
        isLoading,
        isError: false,
        isSuccess: false,
        weekSouscriptionsData: [],
      }
    case actionsTypesMembers.WEEK_SOUSCRIPTIONS_FAILURE :
      return {
        ...previousState,
        isError,
        isSuccess: false,
        weekSouscriptionsData: [],
      }
    case actionsTypesMembers.WEEK_SOUSCRIPTIONS_SUCCESS:
      return {
        ...previousState,
        isSuccess,
        isError: false,
        weekSouscriptionsData,
      }
    default :
      return previousState
  }
}

function initialActivatedPoliciesState() {
  return {
    isLoading: false,
    isError: false,
    isSuccess: false,
    activatedPoliciesData: [],
  }
}
export function getActivatedPolicies(state, action) {
  let previousState = (state ? state : initialActivatedPoliciesState())
  const { isLoading, isError, isSuccess, activatedPoliciesData } = action

  switch (action.type) {
    case actionsTypesMembers.ACTIVATED_POLICIES_REQUEST :
      return {
        ...previousState,
        isLoading,
        isError: false,
        isSuccess: false,
        activatedPoliciesData: [],
      }
    case actionsTypesMembers.ACTIVATED_POLICIES_FAILURE :
      return {
        ...previousState,
        isError,
        isSuccess: false,
        activatedPoliciesData: [],
      }
    case actionsTypesMembers.ACTIVATED_POLICIES_SUCCESS:
      return {
        ...previousState,
        isSuccess,
        isError: false,
        activatedPoliciesData,
      }
    default :
      return previousState
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Parrain/index.js